import React, { useRef, useEffect, useState } from "react";
import { Card, Spinner, Row, Col, Container } from "react-bootstrap";
import Chart from "chart.js/auto";

interface Props {
  dadosPedidos: any;
  loading: boolean;
  error: string | null;
}

const DistribuicaoPedidosChart: React.FC<Props> = ({ dadosPedidos, loading, error }) => {
  const chartRef = useRef<HTMLCanvasElement | null>(null);
  const [chartInstance, setChartInstance] = useState<Chart | null>(null);
  const [listaClientes, setListaClientes] = useState<{ nome: string; percentual: number }[]>([]);

  useEffect(() => {
    if (dadosPedidos?.vendas_x_cliente && chartRef.current) {
      const ctx = chartRef.current.getContext("2d");
      if (!ctx) return;

      // Obtendo os dados
      const pedidosPorCliente = dadosPedidos.vendas_x_cliente.map((cliente: any) => cliente.TOTAL_PEDIDOS);
      const nomesClientes = dadosPedidos.vendas_x_cliente.map((cliente: any) => cliente.NOME_FANTASIA);

      // Calculando percentual de pedidos
      const totalPedidos = pedidosPorCliente.reduce((sum: number, value: number) => sum + value, 0);
      const listaClientesFormatada = nomesClientes.map((nome: string, index: number) => ({
        nome,
        percentual: ((pedidosPorCliente[index] / totalPedidos) * 100).toFixed(2),
      }));
      setListaClientes(listaClientesFormatada);

      // Removendo instância antiga do gráfico antes de criar um novo
      if (chartInstance) {
        chartInstance.destroy();
      }

      const newChart = new Chart(ctx, {
        type: "pie",
        data: {
          labels: nomesClientes,
          datasets: [
            {
              label: "Distribuição de Pedidos",
              data: pedidosPorCliente,
              backgroundColor: [
                "#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF", "#FF9F40",
              ],
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false, // Permite ajuste adequado
          plugins: {
            legend: { position: "bottom" },
          },
        },
      });

      setChartInstance(newChart);
    }
  }, [dadosPedidos]);

  return (
    <Card className="p-3 shadow" style={{minHeight: "300px"}}>
      <h5 className="text-center mb-3">Distribuição de Pedidos por Cliente</h5>
      {loading ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
          <p>Carregando dados...</p>
        </div>
      ) : error ? (
        <div className="text-center text-danger">
          <p>{error}</p>
        </div>
      ) : (
        <Row>
          <Col xs={12} md={6} lg={3} className="d-flex justify-content-center">
            <div className="ratio ratio-1x1 w-100">
              <canvas ref={chartRef}></canvas>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} className="text-center">
            <h6>Lista de Clientes</h6>
            <ul className="list-unstyled">
              {listaClientes.map((cliente, index) => (
                <li key={index} className="mb-2">
                  <strong>{cliente.nome}:</strong> {cliente.percentual}%
                </li>
              ))}
            </ul>
          </Col>
        </Row>
      )}
    </Card>
  );
};

export default DistribuicaoPedidosChart;
